module.exports = __webpack_public_path__ + "img/Metal.2bd2cc84.jpg";